module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-8-8419d605e6d4c42de91541924f238faa.jpg";